import { useQuery } from "urql";

const GLOBAL_SEARCH_QUERY = `query GLOBAL_SEARCH_QUERY($companyId: String!, $searchTerm: String!, $searchField: String!) {
  globalSearch(companyId: $companyId, searchTerm: $searchTerm, searchField: $searchField) {
    status,
    data{
      transactions{
        id
        bankId
        description
        amount
        stringDate
        type
      }
      documents {
        id
        name
        amount
        documentType
        documentDate
        meta {
          ... on TaxDocumentMeta {
            issuerId
            issuerName
            receiverId
            receiverName
            documentCode
            summary
            isReceived
            documentId
          }
        }
        meta {
          ... on ObligationMeta {
            issuerId
            issuerName
            receiverId
            receiverName
            typeLabel
            isReceived
            documentId
          }
        }
      }
      agendas {
        id
        name
        rut
        isClient
        isProvider
      }
    }
  }
}`;

export const GlobalSearchQuery = (variables) => {
  const [result, reexecuteQuery] = useQuery({
    query: GLOBAL_SEARCH_QUERY,
    variables,
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};
